import styled from 'styled-components';

import Button from './Button';

export const SimpleListModalFooter = styled.div`
  margin: 16px -30px 0;
  padding: 14px 30px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  border-top: 1px solid var(--line-gray);
`;

export const SimpleListModalStickyFooter = styled(SimpleListModalFooter)`
  margin-top: auto;
`;

export const SimpleListEntryFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;

  .ant-form-item {
    margin-bottom: 0;
  }
`;

export const SimpleListFieldLabel = styled.div`
  width: 52px;
  flex: 0 0 52px;
  color: var(--text-secondary);
  font-size: 12px;
  font-family: var(--font-bold);
  text-transform: uppercase;
  letter-spacing: 0.03em;
`;

export const SimpleListFieldGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  & + & {
    margin-top: 12px;
  }
`;

export const SimpleListFieldInputContainer = styled.div`
  flex: 1;

  .ant-form-item {
    width: 100%;
  }
`;

export const SimpleListTableEmptyState = styled.div`
  padding: 40px 0;
  color: var(--text-secondary);
  text-align: center;
`;

export const SimpleListActionsButton = styled(Button)`
  width: 100px;
`;

export const SimpleListActionButtonContent = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
